import { Box, CircularProgress } from '@mui/material';
import { theme } from '../../configs/theme';

type Props = {
  width?: string;
  opacity?: number;
};

export const FullPageSpinner = ({ width = '100svw', opacity = 1 }: Props) => {
  return (
    <Box
      flexDirection={'column'}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      sx={{
        height: '100svh',
        width: width,
        position: 'absolute',
        backgroundColor: theme.palette.customColors.cultured,
        top: 0,
        left: 0,
        zIndex: 1300,
        opacity: opacity,
      }}
    >
      <CircularProgress sx={{ color: theme.palette.customColors.emerald }} size="5rem" />
    </Box>
  );
};
